import networkManager from '../NetworkManager/index'
import ApiNames from '../ApiNames/Ordinance'

class Ordinance {
  constructor (context) {
    this.context = context
  }

  async getOrdinance (data) {
    this.context.$store.commit('liveData/set_loading', true)
    const response = await networkManager.getRequest(ApiNames.getOrdinance, data)
    this.context.$store.commit('liveData/set_loading', false)
    return response
  }
}

export default Ordinance
